<!--
 * @Description: 表格 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-27 10:09:52
 * @LastEditors: 思齐
 * @LastEditTime: 2025-11-04 16:22:44
-->
<template>
	<ClientOnly>
		<section class="pc-table-box">
			<h2 class="pc-table-title">{{ title }}</h2>
			<div class="tab">
				<div
					class="tab-item"
					v-for="item in category"
					:class="{ active: item.value === active }"
					:key="item.value"
					@click="
						() => {
							if (loading) return;
							logEvent(`Online_Classification_click`);
							active = item.value;
						}
					"
				>
					<span>{{ item.label }}</span>
				</div>
			</div>
			<n-spin :show="loading">
				<ul>
					<li v-for="item in data" :key="item.id" @click="jump(item.index_uri)">
						<div class="cs-icon">
							<img :src="item.icon" alt="" />
						</div>
						<p class="cs-title">{{ item.title }}</p>
						<p class="desc">{{ item.description }}</p>
					</li>
				</ul>
			</n-spin>
			<n-pagination
				:disabled="loading"
				v-model:page="page"
				:page-count="Math.ceil(total / size) || 0"
				v-show="Math.ceil(total / size) > 1"
			>
				<template #prev>
					<div class="pagination-btn">上一頁</div>
				</template>
				<template #next>
					<div class="pagination-btn">下一頁</div>
				</template>
			</n-pagination>
		</section>
	</ClientOnly>
</template>

<script setup>
import { getCategoryList, getCategoryProduct } from "~/api/api";
import { goLink } from "~/utils/common";
import { ref, watch } from "vue";

const props = defineProps({
	title: {
		type: String,
		default: "",
	},
});

const jump = url => {
	logEvent(`Online_Classification_click`);

	goLink(url, "calc-categories-pc");
};

const active = ref(0);
const category = ref([]);
getCategoryList().then(res => {
	category.value = Object.keys(res.data).map(key => {
		return {
			label: res.data[key],
			value: key,
		};
	});
	active.value = category.value[0].value;
});

const page = ref(1);
const size = ref(10);
const total = ref(0);
const data = ref([]);
const loading = ref(false);
const getList = () => {
	if (loading.value) return;
	loading.value = true;
	getCategoryProduct({
		category_id: active.value,
		page: page.value,
		size: size.value,
	}).then(res => {
		data.value = res.data.list;
		total.value = res.data.pager.total_count;
		loading.value = false;
	});
};

watch(
	() => active.value,
	() => {
		page.value = 1;
		getList();
	}
);

watch(
	() => page.value,
	() => {
		getList();
	}
);

const events = [
	{
		tab: "bazixiangpi",
		event: "site_calc_bazi_click",
	},
	{
		tab: "danrenyinyuan",
		event: "site_calc_single_click",
	},
	{
		tab: "english",
		event: "site_calc_english_click",
	},
	{
		tab: "other",
		event: "site_calc_more_click",
	},
	{
		tab: "shiye",
		event: "site_calc_work_click",
	},
	{
		tab: "tarot",
		event: "site_calc_tarot_click",
	},
	{
		tab: "shuangrenyinyuan",
		event: "site_calc_couple_click",
	},
	{
		tab: "zonghe",
		event: "site_calc_ziwei_click",
	},
];

const findEventByProduct = str => {
	for (const event of events) {
		if (str.includes(event.tab)) {
			return event.event;
		}
	}
	return null;
};

watch(
	() => active.value,
	() => {
		const event = findEventByProduct(active.value);
		event && logEvent(event);
	}
);
</script>

<style lang="scss" scoped>
.pc-table-box {
	margin-top: -12px;
	width: 1008px;
	margin-left: auto;
	margin-right: auto;
	padding: 0;
	display: flex;
	flex-direction: column;
	font-family: PingFang SC;

	.pc-table-title {
		margin: 50px 0 24px;
		font-weight: 500;
		font-size: 20px;
		color: #333333;
		line-height: 28px;
	}

	.tab {
		margin: 0;
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		font-family: PingFang SC;

		.tab-item {
			min-width: 92px;
			padding: 0 16px;
			height: 34px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			font-family:
				PingFang SC,
				PingFang SC;
			font-size: 14px;
			font-weight: 500;
			color: #333333;
			line-height: 20px;
			text-align: center;
			background: #ffffff;
			border-radius: 8px;
			border: 1px solid #ede8e2;
			box-sizing: border-box;
			cursor: pointer;
			transition: all 0.2s ease;
		}

		.active {
			font-weight: 600;
			color: #333333;
			border-color: #333333;
			box-shadow: 0 4px 10px rgba(51, 51, 51, 0.08);
		}
	}

	ul {
		margin: 20px 0 33px;
		display: grid;
		grid-template-columns: repeat(5, minmax(0, 1fr));
		gap: 12px;

		li {
			padding: 10px;
			width: 100%;
			min-width: 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			background-color: #ffffff;
			border-radius: 8px;
			border: 1px solid #ececec;
			box-sizing: border-box;
			cursor: pointer;

			.cs-icon {
				width: 170px;
				height: 170px;
				border-radius: 24px;
				overflow: hidden;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.cs-title {
				margin-top: 12px;
				font-weight: 500;
				font-size: 18px;
				color: #333333;
				line-height: 25px;
				white-space: nowrap; /* 不换行 */
				overflow: hidden; /* 超出部分隐藏 */
				text-overflow: ellipsis; /* 超出部分显示省略号 */
				width: 100%;
			}

			.desc {
				width: 100%;
				margin-top: 6px;
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				line-height: 22px;
				display: -webkit-box;
				line-clamp: 2;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}

:deep(.n-spin) {
	color: #b9703a;
}

.pagination-btn {
	height: 100%;
	padding: 0 16px;
	border-radius: 2px 2px 2px 2px;
	font-family: PingFang TC;
	font-weight: 600;
	font-size: 18px;
	line-height: 36px;
	letter-spacing: 1px;
}

:deep(.n-pagination) {
	justify-content: center;
	--n-item-text-color-hover: #b9703a !important;

	.n-pagination-item {
		white-space: nowrap;
		height: 36px;
		color: #45494e;
		border: 1px solid #e3e4e6 !important;

		&::hover {
			color: #45494e !important;
		}
	}

	.n-pagination-item--disabled {
		.pagination-btn {
			color: #9d9fa2 !important;
		}
	}

	.n-pagination-item--clickable {
		width: 36px;
		height: 36px;
		border-radius: 2px 2px 2px 2px;
	}

	.n-pagination-item--active {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff !important;
		line-height: 23px;
		letter-spacing: 1px;
		background: #b9703a !important;
		border-radius: 2px 2px 2px 2px;
	}
}
</style>
